import React from 'react';

import { Dialog } from '@bessemercws/components/bui';
import { STEP } from '@bessemercws/graphql';
import { useLoginContext } from '@bessemercws/login';
import { useClientContext } from '@bessemercws/providers';

import { WizardStep } from '#/models/WizardStep.enum';
import WizardBody from './WizardBody';
import { useUserVerificationContext } from '../UserVerificationContext/UserVerificationContext';

export const NewUserWizard = () => {
  const { isAdvisor } = useClientContext();
  const { step } = useLoginContext();
  const isTermsConditions = step === STEP.TERMS_CONDITIONS;
  const { email, isVerified, loading, hasPreferencesError } = useUserVerificationContext();

  if (loading || isAdvisor === true || hasPreferencesError || isTermsConditions) {
    return null;
  }

  return (
    <Dialog data-testid="NewUserWizard-Dialog" maxWidth="sm" fullWidth={false} open={!isVerified || !email}>
      <WizardBody currentStep={!email ? WizardStep.Confirm : WizardStep.Deliver} />
    </Dialog>
  );
};

export default NewUserWizard;
